import type { RootState } from "types";

export const getAllTermsById = (state: RootState) => state.domains.language.byId;

export const getIsFetchingTerms = (state: RootState) => state.domains.language.isFetching;

export const getSiteLanguage = (state: RootState) => state.domains.language.siteLanguage;

export const getSiteLanguageLabel = (state: RootState) =>
  state.entities.languages.byId[getSiteLanguage(state)]?.label ?? "English";
